import { ReactComponent as MustardLogo } from "assets/images/logo.svg";
import "./SelfCampaignBrandHeader.scss";

const SelfCampaignBrandHeader: React.FC = () => {
  return (
    <header className="self-campaign-brand-header">
      <div className="self-campaign-brand-header__brand">
        <MustardLogo className="self-campaign-brand-header__logo" />
      </div>
    </header>
  );
};

export default SelfCampaignBrandHeader;
